// import Vue from 'vue';
// import vueConfigManager from 'vue-config-manager';

let staging = window.localStorage.getItem("staging");
let url = "";
let stagingUrl = process.env.STAGING_URL;
let staginPassword = process.env.STAGING_PASSWORD;
let baseUrl = process.env.BASE_URL;

if (staging && staging === "true") {
    url = stagingUrl;
} else {
    url = baseUrl;
}

const config = {
    api: {
        staging: stagingUrl,
        orinalBase: baseUrl,
        staginPassword: staginPassword,
        base: url,
        socket: "https://socket.moneywaveapp.com",
    }
};

// Vue.use(vueConfigManager, config);
export default config;



// WEBPACK FOOTER //
// ./src/config/index.js